import styled, { css } from 'styled-components'
import Flex from 'Components/Flex'
import { BREAK_POINT_LG, BREAK_POINT_MD, BREAK_POINT_SM } from '@CSSVars/variables'
import { TEXT_GREY, HYPER_LINK_COLOR } from '@CSSVars/colors'

import {
  MainContent,
} from '../../components'

export const _FavoriteMain = styled.main`
  padding-bottom: 0;
  overflow-x: hidden;
  h1 {
    font-size: 24px;
  }

`

export const _FavoriteHeader = styled(Flex)`
  width: 100%;
  position: relative;
  height: 100%;
`

export const _TitleAndManageBtn = styled(Flex)`
  flex: 1;
  width: 100%;
  position: relative;
  height: 100%;
  align-items: center;
  padding: 0 72px 0 72px;
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    padding: 24px 40px 40px 40px !important;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    padding: 24px 20px 0 20px !important;
  }
`

export const _Tabs = styled(Flex)`
  position: absolute;
  bottom: 0;
  left: 72px;
  ${({ active }) => (active ? `border: 2px solid ${HYPER_LINK_COLOR}` : '')}
  span {
    font-size: 16px;
    color: ${TEXT_GREY};
  }
  div {
    margin-right: 72px;
    padding: 15px 0;

    &:hover {
      cursor: pointer;
    }
  }
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    left: 40px;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    left: 20px;
  }

  @media screen and (max-width: ${BREAK_POINT_SM}) {
    > div {
      width: 48%;
      margin-right: 24px;
    }
  }

`

export const _Tab = styled.div`
  text-transform: capitalize;
  font-size: 16px;
  margin-right: 72px;
  padding: 12px 0;
  white-space: nowrap;
  ${({ active }) => (active && `
    border-bottom: 3px solid ${HYPER_LINK_COLOR};
  `)};

`

export const _ExtraBottomPadding = css`
  padding-bottom: 100px;
  @media screen and (min-width: ${BREAK_POINT_SM}) and (max-width: ${BREAK_POINT_MD}) {
    padding: 24px 20px 100px 20px !important;
  }
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    padding-bottom: 150px !important;
  }

`

export const _MainContent = styled(MainContent)`
  display: block;
  width: 100%;
  ${({ isMobileApp }) => isMobileApp && _ExtraBottomPadding}
`

export const _TitleInner = styled(Flex)`

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    margin-top: -48px;
  }

`
